// extracted by mini-css-extract-plugin
export default {"tabList":"TabList-module_tabList__J7ixG"};